/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*************************!*\
  !*** ./src/js/login.js ***!
  \*************************/
function passwordReset() {
  var resetPasswordSuccess = document.querySelector('.password-reset-success'),
    loginForm = document.querySelector('.login-form'),
    resetForm = document.querySelector('.password-reset');
  if (typeof resetPasswordSuccess != 'undefined' && resetPasswordSuccess != null) {
    loginForm.style.display = "none";
    resetForm.style.display = "block";
  }
}
passwordReset();
/******/ })()
;